export const HEADERS_SENT_PROCESSES = [
  { name: 'Nombre del proceso', key: 'name' },
  { name: 'Pruebas a aplicar', key: 'categories' },
  { name: 'Cantidad de usuarios', key: 'count_users' },
  { name: 'Usuarios sin responder', key: 'unanswered_users' },
]
